import React from 'react';
import { theme } from '../../theme';
import { useLanguage } from '../../i18n';
import { LanguageToggle } from '../LanguageToggle';

type CloudActStepProps = {
  value: boolean | null;
  onChange: (value: boolean) => void;
  onProceed: () => void;
  onClose: () => void;
};

export const CloudActStep: React.FC<CloudActStepProps> = ({
  value,
  onChange,
  onProceed,
  onClose,
}) => {
  const { t } = useLanguage();

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'transparent',
        color: theme.text,
        fontFamily: 'Arial, sans-serif',
      }}
    >
      {/* Header */}
      <header
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 2000,
          background: 'rgba(255,255,255,0.85)',
          borderBottom: '1px solid rgba(255,106,76,0.3)',
          backdropFilter: 'blur(6px)',
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: '0 auto',
            padding: '10px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              cursor: 'pointer',
            }}
            onClick={onClose}
          >
            <img
              src="/sovlogo.png"
              alt="Go-Sovereign"
              className="logo-desktop"
              style={{
                height: 50,
                userSelect: 'none',
                pointerEvents: 'none',
              }}
            />
            <img
              src="/sovicon.png"
              alt="Go-Sovereign Icon"
              className="logo-mobile"
              style={{
                height: 36,
                userSelect: 'none',
                pointerEvents: 'none',
              }}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <LanguageToggle />
            <button
              onClick={onClose}
              style={{
                border: '1px solid #FF6A4C',
                background: 'transparent',
                color: '#FF6A4C',
                padding: '6px 14px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              {t('questionnaire.close')}
            </button>
          </div>
        </div>
      </header>

      {/* Spacer */}
      <div style={{ height: 64 }} />

      {/* Content */}
      <section style={{ maxWidth: 900, margin: '0 auto', padding: 16, borderRadius: 3 }}>
        <h2 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>
          {t('cloudAct.title')}
        </h2>

        {/* Options */}
        <div style={{ marginTop: 16 }}>
          <label
            style={{
              display: 'flex',
              gap: 8,
              alignItems: 'center',
              padding: '8px 12px',
              borderRadius: 6,
              cursor: 'pointer',
              border: `1px solid ${theme.border}`,
              marginBottom: 8,
              background: value === true ? theme.primarySoft : 'rgba(255,255,255,0.9)',
            }}
          >
            <input
              type="radio"
              name="cloud-act"
              checked={value === true}
              onChange={() => onChange(true)}
              style={{ accentColor: theme.primary }}
            />
            <span style={{ fontSize: 15, fontWeight: 600 }}>{t('cloudAct.yes')}</span>
          </label>

          <label
            style={{
              display: 'flex',
              gap: 8,
              alignItems: 'center',
              padding: '8px 12px',
              borderRadius: 6,
              cursor: 'pointer',
              border: `1px solid ${theme.border}`,
              marginBottom: 8,
              background: value === false ? theme.primarySoft : 'rgba(255,255,255,0.9)',
            }}
          >
            <input
              type="radio"
              name="cloud-act"
              checked={value === false}
              onChange={() => onChange(false)}
              style={{ accentColor: theme.primary }}
            />
            <span style={{ fontSize: 15, fontWeight: 600 }}>{t('cloudAct.no')}</span>
          </label>
        </div>

        {/* Proceed Button */}
        <button
          onClick={onProceed}
          disabled={value === null}
          style={{
            marginTop: 12,
            border: `1px solid ${theme.primaryBorder}`,
            background: value !== null ? theme.primarySoft : '#eee',
            padding: '8px 14px',
            cursor: value !== null ? 'pointer' : 'not-allowed',
            fontWeight: 700,
          }}
        >
          {t('cloudAct.proceed')}
        </button>
      </section>
    </div>
  );
};
